var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadblock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.002 512.002",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB0125"
    },
    d: "M88.209,465.263H45.432v-67.707v-1.858v-27.984V23.832c0-4.538,3.678-8.216,8.216-8.216h26.346 c4.538,0,8.216,3.678,8.216,8.216v441.431H88.209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB0125"
    },
    d: "M465.926,465.263h-42.777V23.832c0-4.538,3.678-8.216,8.216-8.216h26.346 c4.538,0,8.216,3.678,8.216,8.216v441.431H465.926z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 423.15,
    y: 329.845,
    style: {
      fill: "#BA041F"
    },
    width: 42.777,
    height: 30.389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.433,
    y: 329.845,
    style: {
      fill: "#BA041F"
    },
    width: 42.777,
    height: 30.389
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC111E"
    },
    d: "M79.993,15.616H54.149c4.538,0,8.216,3.678,8.216,8.216v441.431h25.844V23.832 C88.209,19.294,84.531,15.616,79.993,15.616z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.369,
    y: 329.845,
    style: {
      fill: "#9A0314"
    },
    width: 25.844,
    height: 30.389
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7C5CB"
    },
    d: "M107.889,465.263H25.752c-3.698,0-6.696,2.998-6.696,6.696v17.732c0,3.698,2.998,6.696,6.696,6.696 h82.138c3.698,0,6.696-2.998,6.696-6.696v-17.732C114.585,468.261,111.587,465.263,107.889,465.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEADB3"
    },
    d: "M88.209,465.263v31.123h19.68c3.698,0,6.696-2.998,6.696-6.696v-17.732 c0-3.698-2.998-6.696-6.696-6.696L88.209,465.263L88.209,465.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC111E"
    },
    d: "M457.71,15.616h-26.346c-0.005,0-0.011,0.001-0.015,0.001c4.53,0.009,8.2,3.683,8.2,8.215v441.431 h26.376V23.832C465.926,19.294,462.248,15.616,457.71,15.616z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.548,
    y: 329.845,
    style: {
      fill: "#9A0314"
    },
    width: 26.376,
    height: 30.389
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7C5CB"
    },
    d: "M485.606,465.263h-82.138c-3.698,0-6.696,2.998-6.696,6.696v17.732c0,3.698,2.998,6.696,6.696,6.696 h82.138c3.698,0,6.696-2.998,6.696-6.696v-17.732C492.302,468.261,489.305,465.263,485.606,465.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEA921"
    },
    d: "M492.182,329.847H19.176c-6.316,0-11.438-5.12-11.438-11.438V66.5c0-6.316,5.12-11.438,11.438-11.438 h473.008c6.316,0,11.438,5.12,11.438,11.438V318.41C503.62,324.727,498.5,329.847,492.182,329.847z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2F2F2"
    },
    points: "275.755,55.062 216.056,55.062 121.044,329.847 180.743,329.847  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M7.738,96.416l14.298-41.354h-2.862c-6.316,0-11.438,5.12-11.438,11.438v29.916H7.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M89.197,55.062L7.738,290.652v27.758c0,6.316,5.12,11.438,11.438,11.438h34.709l95.012-274.785 H89.197z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2F2F2"
    },
    points: "402.613,55.062 342.914,55.062 247.902,329.847 307.601,329.847  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M503.62,129.827V66.5c0-6.316-5.12-11.438-11.438-11.438h-22.409l-95.012,274.785h59.699 L503.62,129.827z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEADB3"
    },
    d: "M465.926,465.263v31.123h19.68c3.698,0,6.696-2.998,6.696-6.696v-17.732 c0-3.698-2.998-6.696-6.696-6.696L465.926,465.263L465.926,465.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E58200"
    },
    d: "M492.182,55.062h-29.743c6.316,0,11.438,5.12,11.438,11.438v213.674 c0,11.007-8.923,19.93-19.93,19.93H7.738v18.306c0,6.316,5.12,11.438,11.438,11.438H462.44h29.743c4.342,0,8.121-2.42,10.057-5.985 c0.352-0.648,0.644-1.335,0.866-2.05c0.112-0.358,0.205-0.724,0.282-1.096c0.153-0.745,0.232-1.515,0.232-2.305l0,0v-18.306V66.5 C503.62,60.183,498.499,55.062,492.182,55.062z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M503.62,66.5c0-4.342-2.42-8.121-5.985-10.057C501.199,58.379,503.62,62.156,503.62,66.5v63.329l0,0 V66.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M7.738,318.41v-18.306l0,0V318.41c0,6.316,5.12,11.438,11.437,11.438l0,0 C12.858,329.847,7.738,324.727,7.738,318.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M492.182,55.062c1.974,0,3.831,0.5,5.451,1.381C496.013,55.562,494.156,55.062,492.182,55.062 h-29.743c2.463,0,4.738,0.786,6.604,2.109l0.73-2.109H492.182z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCCCCC"
    },
    points: "131.328,300.104 121.044,329.847 180.743,329.847 191.027,300.104  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M7.738,300.104v18.306c0,6.316,5.12,11.438,11.438,11.438h34.709l10.284-29.743H7.738z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCCCCC"
    },
    points: "258.187,300.104 247.904,329.847 307.601,329.847 317.886,300.104  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M497.635,56.443c-1.62-0.88-3.477-1.381-5.451-1.381h-22.409l-0.73,2.109 c2.922,2.072,4.833,5.474,4.833,9.327v149.349l29.743-86.021V66.5C503.62,62.156,501.199,58.379,497.635,56.443z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCCCCC"
    },
    points: "385.045,300.104 374.762,329.847 434.46,329.847 444.744,300.104  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A1A1A"
    },
    d: "M492.504,47.003h-18.517V23.832c0-8.975-7.302-16.276-16.276-16.276h-26.346 c-8.975,0-16.276,7.301-16.276,16.276v23.171H96.269V23.832c0-8.975-7.301-16.276-16.276-16.276H53.649 c-8.975,0-16.276,7.301-16.276,16.276v23.171H19.497C8.746,47.003,0,55.748,0,66.5V318.41c0,10.751,8.746,19.497,19.497,19.497 h17.876v48.381c0,4.452,3.608,8.059,8.059,8.059s8.059-3.607,8.059-8.059v-48.381H80.15v119.297H53.492v-40.909 c0-4.452-3.608-8.059-8.059-8.059s-8.059,3.607-8.059,8.059v40.909H25.751c-8.136,0-14.754,6.618-14.754,14.754v17.733 c0,8.136,6.619,14.754,14.754,14.754h82.138c8.136,0,14.754-6.618,14.754-14.754v-17.733c0-8.136-6.619-14.754-14.754-14.754H96.269 V337.906H415.09v48.119c0,4.452,3.607,8.059,8.059,8.059c4.452,0,8.059-3.607,8.059-8.059v-48.119h26.659v119.297h-26.659v-40.619 c0-4.452-3.607-8.059-8.059-8.059c-4.452,0-8.059,3.607-8.059,8.059v40.619h-11.621c-8.136,0-14.754,6.618-14.754,14.754v17.733 c0,8.136,6.618,14.754,14.754,14.754h82.138c8.136,0,14.755-6.618,14.755-14.754v-17.733c0-8.136-6.619-14.754-14.755-14.754 h-11.619V337.906h18.517c10.751,0,19.497-8.746,19.497-19.497V66.5C512,55.748,503.255,47.003,492.504,47.003z M106.526,488.327 h-79.41v-15.004h18.316h42.777h18.316C106.526,473.322,106.526,488.327,106.526,488.327z M484.242,488.327h-79.41v-15.004h18.316 h42.778h18.316v15.004H484.242z M431.208,23.832c0-0.086,0.07-0.157,0.157-0.157h26.346c0.087,0,0.157,0.07,0.157,0.157v23.171 h-26.659V23.832z M53.492,23.832c0-0.086,0.07-0.157,0.157-0.157h26.346c0.086,0,0.157,0.07,0.157,0.157v23.171H53.492V23.832z  M495.881,318.41c0,1.862-1.515,3.379-3.379,3.379h-26.577h-42.778H88.209H45.432H19.497c-1.862,0-3.378-1.515-3.378-3.379V66.5 c0-1.862,1.515-3.378,3.378-3.378h25.935h42.777h334.94h42.778h26.577c1.862,0,3.379,1.515,3.379,3.378V318.41H495.881z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadblock);
export default __webpack_public_path__ + "static/media/roadblock.4c22f687b93085ed03c5182c9f0c582e.svg";
export { ForwardRef as ReactComponent };